import styled, { keyframes } from 'styled-components';

import { useScrollFadeIn } from 'hooks/useScrollFadeIn';

import HeroVideo from 'resources/videoLanding/hero_video.mp4';

const HeroSection = () => {

  const largeBottomUpAnime = useScrollFadeIn({threshold: 0.1, delay: '0.3', direction: 'bottomUp'});
  const smallBottomUpAnime = useScrollFadeIn({threshold: 0.1, delay: '0.9', direction: 'bottomUp'});
  const mLargeBottomUpAnime = useScrollFadeIn({threshold: 0.1, delay: '0.3', direction: 'bottomUp'});
  const mSmallBottomUpAnime = useScrollFadeIn({threshold: 0.1, delay: '0.9', direction: 'bottomUp'});

  return (
    <Container>    
      <ShadowBox />
      <video muted autoPlay loop playsInline>
        <source src={HeroVideo} type='video/mp4' />
        <strong>동영상 태그를 지원하지 않는 브라우저 입니다.</strong>
      </video>
      <HeroContainer>
        <LargeText {...largeBottomUpAnime}>
          <div>쉽고 믿을 수 있는</div>
          <div className='accent'>영상 제작</div>
          <div>
            <span>촬영 파트너 </span>
            <AccentText>브</AccentText>
            <AccentText>리</AccentText>
            <AccentText>피</AccentText>  
            <span>가 함께합니다</span>
          </div>
        </LargeText>
        <MobileLargeText {...mLargeBottomUpAnime}>
          <div>쉽고 믿을 수 있는</div>
          <div className='accent'>영상 제작</div>
          <div>
            <span>촬영 파트너 </span>
            <AccentText>브</AccentText>
            <AccentText>리</AccentText>
            <AccentText>피</AccentText>
            <span>가</span>
          </div>
          <div>함께합니다</div>
        </MobileLargeText>
        <SmallText {...smallBottomUpAnime}>
          <div>성공적인 비주얼이 구현될 수 있도록</div>
          <div>브리피가 제작사 연결부터 최종 납품까지 전 과정을 함께합니다.</div>
        </SmallText>
        <MobileSmallText {...mSmallBottomUpAnime}>
          <div>성공적인 비주얼이 구현될 수 있도록</div>
          <div>브리피가 제작사 연결부터 최종 납품까지</div>
          <div>전 과정을 함께합니다.</div>
        </MobileSmallText>
      </HeroContainer>
    </Container>
  )
}

export default HeroSection;

const Container = styled.div`
  display: flex;
  width: 100%;  
  height: 950px;
  margin: 0 auto;
  background: #000000;
  position: relative;
  video {
    width: 100%;
  }
  @media ${({theme}) => theme.device.mobile} {
    height: 568px;
    overflow: hidden;
    video {
      width: 144vh;
      height: 568px;
    }
  }
`

const ShadowBox = styled.div`
  width: 100%;
  height: 100%;
  z-index: 1;
  position: absolute;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.1), #000000);
  @media ${({theme}) => theme.device.mobile} {
    height: 616px;
  }
`

const HeroContainer = styled.div`
  z-index: 2;
  height: 950px;
  margin: 80px auto 0;
  padding-top: 186px;
  text-align: center;
  
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  @media ${({theme}) => theme.device.mobile} {
    width: 100%;
    height: 568px;
    margin: 148px auto 0;
    padding: 0;
  }
`

const shine = keyframes`
  0% { background-position: 0; }
  60% { background-position: 400px; }
  100% { background-position: 560px; }
`

const LargeText = styled.div`
  color: #FFFFFF;
  font-size: 60px;
  font-weight: 700;
  line-height: 96px;
  .accent {
    color: #FE5A1D;
    font-size: 150px;
    font-weight: 700;
    line-height: 170px;
    // position: absolute;
    // top: 39%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    // background: linear-gradient(to right, #4B4B4B 0%, #FFFFFF 3%, #4B4B4B 20%);
    // background-position: 0;
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
    // animation: ${shine} 3s infinite linear;
    // animation-fill-mode: forwards;
    // -webkit-text-size-adjust: none;
  }
  // div:first-child {
  //   margin-bottom: 185px;
  // }
  @media ${({theme}) => theme.device.mobile} {
    display: none;
  }
`

const MobileLargeText = styled.div`
  display: none;
  @media ${({theme}) => theme.device.mobile} {
    display: block;
    color: #FFFFFF;
    font-size: 32px;
    font-weight: 700;
    line-height: 38px;
    .accent {
      margin: 10px 0 18px;
      color: #FE5A1D;
      font-size: 64px;
      line-height: 70px;
    }
  }
`

const AccentText = styled.span`
  display: inline-block;
  position: relative;
  ::before {
    content: '';
    position: absolute;
    top: 0px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 50%;
    width: 11px;
    height: 11px;
    background-color: #FE5A1D;
  }
  @media ${({theme}) => theme.device.mobile} {
    ::before {
      content: '';
      position: absolute;
      top: -6px;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 50%;
      width: 6px;
      height: 6px;
      background-color: #FE5A1D;
    }
  }
`

const SmallText = styled.div`
  margin-top: 45px;
  color: #FFFFFF;
  font-size: 24px;
  font-weight: 400;
  line-height: 38px;
  @media ${({theme}) => theme.device.mobile} {
    display: none;
  }
`

const MobileSmallText = styled(SmallText)`
  display: none;
  
  @media ${({theme}) => theme.device.mobile} {
    display: block;
    margin-top: 99px;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 400;
    line-height: 22px;
  }
`
